import {
  Box,
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  Flex,
  Heading,
  Text,
  useColorModeValue,
} from '@chakra-ui/react';
import PropTypes from 'prop-types';
import React, { useState, useEffect } from 'react';
import AdminNavbarLinks from 'components/navbar/NavbarLinksAdmin';

export default function AdminNavbar(props) {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    window.addEventListener('scroll', changeNavbar);

    return () => {
      window.removeEventListener('scroll', changeNavbar);
    };
  });

  const { secondary, message, brandText } = props;

  // Here are all the props that may change depending on navbar's type or state.(secondary, variant, scrolled)
  let mainText = useColorModeValue('navy.800', 'white');
  let secondaryText = useColorModeValue(
    'secondaryGray.700',
    'secondaryGray.500',
  );
  let navbarPosition = 'fixed';
  let navbarFilter = 'none';
  let navbarBackdrop = 'blur(20px)';
  let navbarShadow = useColorModeValue(
    '0 20px 44px rgba(31, 52, 112, 0.10)',
    '0 22px 54px rgba(2, 8, 23, 0.28)',
  );
  let navbarBg = useColorModeValue(
    'rgba(255,255,255,0.72)',
    'rgba(17, 23, 39, 0.72)',
  );
  let navbarBorder = useColorModeValue(
    'rgba(162,176,210,0.18)',
    'rgba(255,255,255,0.08)',
  );
  let secondaryMargin = '0px';
  let paddingX = '15px';
  let gap = '0px';
  const changeNavbar = () => {
    if (window.scrollY > 1) {
      setScrolled(true);
    } else {
      setScrolled(false);
    }
  };

  return (
    <Box
      position={navbarPosition}
      boxShadow={navbarShadow}
      bg={navbarBg}
      borderColor={navbarBorder}
      filter={navbarFilter}
      backdropFilter={navbarBackdrop}
      backgroundPosition="center"
      backgroundSize="cover"
      borderRadius={{ base: '20px', md: '24px' }}
      borderWidth="1px"
      borderStyle="solid"
      transitionDelay="0s, 0s, 0s, 0s"
      transitionDuration=" 0.25s, 0.25s, 0.25s, 0s"
      transition-property="box-shadow, background-color, filter, border"
      transitionTimingFunction="linear, linear, linear, linear"
      alignItems={{ xl: 'center' }}
      display={secondary ? 'block' : 'flex'}
      minH={{ base: '78px', md: '92px' }}
      justifyContent={{ xl: 'center' }}
      lineHeight="25.6px"
      mx="auto"
      mt={secondaryMargin}
      pb={{ base: '12px', md: '14px' }}
      left={{ base: '12px', md: '30px', lg: '30px', xl: '350px' }}
      right={{ base: '12px', md: '30px', lg: '30px', xl: '30px' }}
      px={{
        base: '12px',
        sm: paddingX,
        md: '10px',
      }}
      ps={{
        xl: '18px',
      }}
      pt={{ base: '12px', md: '14px' }}
      top={{ base: '12px', md: '18px', lg: '24px', xl: '24px' }}
      w="auto"
      maxW="none"
    >
      <Box w="100%">
        <Breadcrumb mb="10px">
          <BreadcrumbItem
            color={secondaryText}
            fontSize="xs"
            textTransform="uppercase"
            letterSpacing="0.16em"
            fontWeight="700"
          >
            <BreadcrumbLink href="#" color={secondaryText}>
              Pages
            </BreadcrumbLink>
          </BreadcrumbItem>

          <BreadcrumbItem
            color={secondaryText}
            fontSize="xs"
            textTransform="uppercase"
            letterSpacing="0.16em"
            fontWeight="700"
          >
            <BreadcrumbLink href="#" color={secondaryText}>
              {brandText}
            </BreadcrumbLink>
          </BreadcrumbItem>
        </Breadcrumb>
        <Flex
          w="100%"
          alignItems="center"
          justifyContent="space-between"
          gap={{ base: '8px', md: '16px' }}
          mb={gap}
        >
          <Heading
            color={mainText}
            fontSize={{ base: '18px', sm: '22px', md: '34px' }}
            lineHeight={{ base: '1.1', md: '1' }}
            flex="1"
            minW="0"
            whiteSpace={{ base: 'normal', md: 'nowrap' }}
            wordBreak="break-word"
          >
            {brandText}
          </Heading>
          <Box w="fit-content" alignSelf="center" flexShrink={0}>
            <AdminNavbarLinks
              onOpen={props.onOpen}
              logoText={props.logoText}
              secondary={props.secondary}
              fixed={props.fixed}
              scrolled={scrolled}
            />
          </Box>
        </Flex>
      </Box>
      {secondary ? <Text color="white">{message}</Text> : null}
    </Box>
  );
}

AdminNavbar.propTypes = {
  brandText: PropTypes.string,
  variant: PropTypes.string,
  secondary: PropTypes.bool,
  fixed: PropTypes.bool,
  onOpen: PropTypes.func,
};
